import { rem } from 'polished'
import styled from 'styled-components'
import { DRAWER_DETAIL_CONTENT_WIDTH } from '../constants'
import { DrawerBodyContentWrapper } from '../drawerBodyLayout.styles'

export const ContentWrapper = styled(DrawerBodyContentWrapper)`
  max-width: ${rem(DRAWER_DETAIL_CONTENT_WIDTH)};
`
